import { getCookie, setCookie } from '@atlassian/jira-browser-storage-controls';
import { fireErrorAnalytics } from '@atlassian/jira-errors-handling';

const CROSS_JOIN_NUDGES_CONFLUENCE_VISITED_KEY = 'cross.join.nudges.confluence.visited';
const CROSS_JOIN_NUDGES_CONFLUENCE_VISITED_COUNT_KEY = 'cross.join.nudges.confluence.visited.count';
const SNOOZE_DAYS_AFTER_FEATURE_IGNORED = 7;
const SNOOZE_DAYS_AFTER_NOT_INTERESTED_CLICKED = 30;

export const isFeatureVisited = async () => {
	try {
		if (getFeatureVisited()) {
			return true;
		}
		await snoozeFeatureFor7Days();
		return false;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			meta: {
				id: 'useFeatureVisited',
				packageName: 'jiraCrossJoinNudges',
			},
			error,
			sendToPrivacyUnsafeSplunk: true,
		});
		return false;
	}
};

const setFeatureVisited = async (expires: number) => {
	await setCookie(CROSS_JOIN_NUDGES_CONFLUENCE_VISITED_KEY, 'true', {
		expires,
	});
};

const snoozeFeatureFor7Days = async () => {
	await setFeatureVisited(SNOOZE_DAYS_AFTER_FEATURE_IGNORED);
};

export const snoozeFeatureFor30Days = async () => {
	await setFeatureVisited(SNOOZE_DAYS_AFTER_NOT_INTERESTED_CLICKED);
};

const getFeatureVisited = () => getCookie(CROSS_JOIN_NUDGES_CONFLUENCE_VISITED_KEY) === 'true';

export const getFeatureVisitedCount = (): number => {
	const value = parseInt(getCookie(CROSS_JOIN_NUDGES_CONFLUENCE_VISITED_COUNT_KEY) || '', 10);
	return !Number.isNaN(value) ? value : 0;
};

export const increaseFeatureVisitedCount = async () => {
	const currentCount = parseInt(
		getCookie(CROSS_JOIN_NUDGES_CONFLUENCE_VISITED_COUNT_KEY) || '',
		10,
	);
	const nextCount = (Number.isNaN(currentCount) ? 0 : currentCount) + 1;
	await setCookie(CROSS_JOIN_NUDGES_CONFLUENCE_VISITED_COUNT_KEY, nextCount.toString());
};
